import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/register',
      name: '',
      meta: {
        title: '注册'
      },
      component: resolve => require(['@/pages/Register'], resolve),
      hidden: true
    },
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/pages/Index'], resolve),
      children: [
        {
          path: '/',
          component: resolve => require(['@/pages/IndexSub/Index'], resolve),
          name: '首页'
        },
        {
          path: '/index',
          component: resolve => require(['@/pages/IndexSub/Index'], resolve),
          name: '首页'
        },
        {
          path: '/list/:id',
          component: resolve => require(['@/pages/IndexSub/List'], resolve),
          name: '列表页',
          props: true
        },
        {
          path: '/diqu/:hangye',
          component: resolve => require(['@/pages/IndexSub/Diqu'], resolve),
          name: '地区分页',
          props: true
        },
        {
          path: '/search/:keyword',
          component: resolve => require(['@/pages/IndexSub/Search'], resolve),
          name: '搜索页',
          props: true
        },
        {
          path: '/detail/:id',
          component: resolve => require(['@/pages/IndexSub/Detail'], resolve),
          name: '详情页',
          props: true
        },
        {
          path: '/free',
          component: resolve => require(['@/pages/IndexSub/Free'], resolve),
          name: '免费浏览',
          props: true
        },
        {
          path: '/free/:keyword',
          component: resolve => require(['@/pages/IndexSub/Free'], resolve),
          name: '免费浏览搜索',
          props: true
        },
        {
          path: '/freedetail/:id',
          component: resolve => require(['@/pages/IndexSub/FreeDetail'], resolve),
          name: '免费详情页',
          props: true
        },
        {
          path: '/publish',
          name: 'Publish',
          meta: {
            title: '发布信息'
          },
          component: resolve => require(['@/pages/Publish'], resolve),
          hidden: false
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js